import React from 'react';

const NormalFormLabel = ({text}) => (
  <div className="flex items-center">
    <span className="font-roboto text-[14px] font-medium leading-5 tracking-[0.005em]">{text}</span>
  </div>
);

export default NormalFormLabel;